// eslint-disable-next-line import/no-cycle
import { createApiActionTypes } from 'store';

export const GET_USER_DATA = createApiActionTypes('GET_USER_DATA');
export const UPDATE_USER_NAME = 'UPDATE_USER_NAME';

export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
